/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
export const TabCardViewKeys = {
  ongoing: "ongoing",
  history: "history",
}

export const TabCardViewName = new Map<string, string>([
  ["ongoing", "ordermanager.tab.ongoing"],
  ["history", "ordermanager.tab.history"],
])

// Key order drives tab order — `returnRefund` sits 4th, between `upcoming` and `history`.
// Each key must equal its value: tabs render from `Object.keys` and push the key straight
// into the URL, and `getViewMode` matches the URL segment against `Object.keys` too.
export const TabTableViewKeys = {
  preparing: "preparing",
  ready: "ready",
  upcoming: "upcoming",
  returnRefund: "returnRefund",
  history: "history",
}

export const TabTableViewKeysOfMexSupplier = {
  preparing: "preparing",
  delivering: "delivering",
  upcoming: "upcoming",
  returnRefund: "returnRefund",
  history: "history",
}

// No `returnRefund` entry — its label is still placeholder copy in `RETURN_REFUND_TEXT`
// and gets a PhraseApp key (`ordermanager.tab.returnRefund`) before release.
export const TabTableViewName = new Map<string, string>([
  ["preparing", "ordermanager.tab.preparing"],
  ["ready", "ordermanager.tab.ready"],
  ["delivering", "ordermanager.tab.delivering"],
  ["upcoming", "ordermanager.tab.upcoming"],
  ["history", "ordermanager.tab.history"],
])

export const DEFAULT_TAB_VIEW_KEY = TabTableViewKeys.preparing
